// apps/client/src/assets/builders/shovel.ts
import * as THREE from 'three';
import { RoundedBoxGeometry } from 'three/addons/geometries/RoundedBoxGeometry.js';
import { toyMaterial } from '../../characters/doll';
import type { CodeBuilder } from '../service';
export const builder: CodeBuilder = {
  id: 'shovel',
  build() {
    const g = new THREE.Group(); g.name = 'shovel';
    const handle = new THREE.Mesh(new THREE.CylinderGeometry(0.022, 0.022, 0.95, 8), toyMaterial('#B08A63')); handle.position.y = 0.62;
    const grip = new THREE.Mesh(new THREE.CapsuleGeometry(0.03, 0.16, 4, 8).rotateZ(Math.PI / 2), toyMaterial('#5E4733')); grip.position.y = 1.1;
    const blade = new THREE.Mesh(new RoundedBoxGeometry(0.24, 0.3, 0.04, 3, 0.03), toyMaterial('#A9B4B8')); blade.position.y = 0.15;
    g.add(handle, grip, blade);
    return g;
  },
};
